var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVsc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_30_437",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 101,
    height: 101
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.3422 100.445C72.9267 101.068 74.7337 101.028 76.3332 100.252L97.0465 90.2068C99.2229 89.1512 100.607 86.9307 100.607 84.4952V16.3815C100.607 13.9459 99.2229 11.7257 97.0465 10.6701L76.3332 0.624498C74.2342 -0.393432 71.7776 -0.144102 69.9356 1.20571C69.6723 1.39853 69.4216 1.61383 69.1866 1.85108L29.5333 38.3123L12.2612 25.0981C10.6533 23.868 8.40434 23.9688 6.91103 25.3379L1.3713 30.4167C-0.455299 32.0914 -0.457393 34.9876 1.36678 36.665L16.3457 50.4381L1.36678 64.2114C-0.457393 65.8888 -0.455299 68.785 1.3713 70.4597L6.91103 75.5384C8.40434 76.9077 10.6533 77.0083 12.2612 75.7784L29.5333 62.564L69.1866 99.0254C69.8138 99.6579 70.5503 100.134 71.3422 100.445ZM75.4706 27.4194L45.3828 50.4381L75.4706 73.4569V27.4194Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_30_437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.1079 10.6859L76.3785 0.626451C73.9793 -0.53793 71.1116 -0.046768 69.2283 1.85114L1.36761 64.2115C-0.457672 65.889 -0.455574 68.7852 1.37214 70.4598L6.91522 75.5385C8.40947 76.9078 10.6598 77.0084 12.2686 75.7786L93.9887 13.2956C96.7302 11.1994 100.668 13.1702 100.668 16.6385V16.396C100.668 13.9614 99.2843 11.7421 97.1079 10.6859Z",
    fill: "#0065A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1079 90.1903L76.3785 100.25C73.9793 101.414 71.1116 100.923 69.2283 99.0251L1.36761 36.6647C-0.457672 34.9874 -0.455574 32.091 1.37214 30.4164L6.91522 25.3375C8.40947 23.9684 10.6598 23.8676 12.2686 25.0978L93.9887 87.5805C96.7302 89.6766 100.668 87.706 100.668 84.2375V84.4803C100.668 86.9146 99.2843 89.1339 97.1079 90.1903Z",
    fill: "#007ACC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3135 100.258C73.9135 101.421 71.0458 100.93 69.1626 99.0318C71.4828 101.37 75.4505 99.7139 75.4505 96.4065V4.48248C75.4505 1.17511 71.4828 -0.481238 69.1626 1.85743C71.0458 -0.0406504 73.9135 -0.532505 76.3135 0.630847L97.0393 10.6765C99.2173 11.7321 100.602 13.9522 100.602 16.3879V84.5016C100.602 86.9372 99.2173 89.1573 97.0393 90.2129L76.3135 100.258Z",
    fill: "#1F9CF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3423 100.445C72.9268 101.067 74.7338 101.028 76.3329 100.252L97.0462 90.2065C99.223 89.1509 100.607 86.9308 100.607 84.4952V16.3815C100.607 13.9458 99.223 11.7257 97.0466 10.6701L76.3329 0.624501C74.2343 -0.393432 71.7777 -0.144103 69.9353 1.20571C69.6724 1.39853 69.4217 1.61382 69.1863 1.85108L29.5332 38.3123L12.2611 25.0981C10.6533 23.868 8.40432 23.9688 6.91101 25.3378L1.3713 30.4167C-0.455299 32.0914 -0.457393 34.9877 1.36678 36.665L16.3457 50.4382L1.36678 64.2114C-0.457393 65.8889 -0.455299 68.7851 1.3713 70.4598L6.91101 75.5384C8.40432 76.9077 10.6533 77.0083 12.2611 75.7785L29.5332 62.5641L69.1863 99.0254C69.8135 99.658 70.5504 100.134 71.3423 100.445ZM75.4707 27.4194L45.3829 50.4382L75.4707 73.457V27.4194Z",
    fill: "url(#paint0_linear_30_437)",
    fillOpacity: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30_437",
    x1: 50.3036,
    y1: -3.95078e-7,
    x2: 50.3036,
    y2: 100.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVsc);
export default __webpack_public_path__ + "static/media/VSC.c9be80da88651a682cafe9eeb3fc228d.svg";
export { ForwardRef as ReactComponent };